import { create } from "zustand";
import api from "../services/api";
import { ENDPOINTS } from "../utils/endpoints";

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  isOpen: false,

  setIsOpen: (open) => set({ isOpen: open }),

  fetchUnreadCount: async () => {
    try {
      const { data } = await api.get(ENDPOINTS.GET_NOTIFICATIONS_UNREAD_COUNT);
      if (data.success) set({ unreadCount: data.count || 0 });
    } catch (err) {
      // silent
    }
  },

  fetchNotifications: async () => {
    set({ isLoading: true });
    try {
      const { data } = await api.get(ENDPOINTS.GET_NOTIFICATIONS);
      if (data.success) {
        set({ notifications: data.notifications || [] });
      }
    } catch (err) {
      console.error("fetchNotifications failed", err);
    } finally {
      set({ isLoading: false });
    }
  },

  markRead: async (id) => {
    try {
      await api.patch(ENDPOINTS.MARK_NOTIFICATION_READ(id));
      set((state) => ({
        notifications: state.notifications.map((n) =>
          n.id === id ? { ...n, is_read: 1 } : n,
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      }));
    } catch (err) {
      console.error("markRead failed", err);
    }
  },

  markAllRead: async () => {
    try {
      await api.post(ENDPOINTS.MARK_ALL_NOTIFICATIONS_READ);
      set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, is_read: 1 })),
        unreadCount: 0,
      }));
    } catch (err) {
      console.error("markAllRead failed", err);
    }
  },

  deleteNotification: async (id) => {
    try {
      await api.delete(ENDPOINTS.DELETE_NOTIFICATION(id));
      set((state) => {
        const removed = state.notifications.find((n) => n.id === id);
        return {
          notifications: state.notifications.filter((n) => n.id !== id),
          unreadCount:
            removed && !removed.is_read
              ? Math.max(0, state.unreadCount - 1)
              : state.unreadCount,
        };
      });
    } catch (err) {
      console.error("deleteNotification failed", err);
    }
  },

  reset: () => set({ notifications: [], unreadCount: 0, isOpen: false }),
}));

export default useNotificationStore;
